"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEmail = void 0;
const validation_1 = require("../validation/validation");
/**
 * @summary Creates a validation for email fields.
 *
 * @param {string | undefined} message
 * @returns {Validation}
 *
 * @see Validation
 */
function isEmail(message) {
    return (0, validation_1.validation)(message ?? 'The given value is not an email.', (value) => {
        if (typeof value !== 'string')
            return false;
        const at = value.lastIndexOf('@');
        return at > 0 && value.lastIndexOf('.') > at && value.length - at > 4;
    });
}
exports.isEmail = isEmail;
